import React, { Suspense } from 'react'
import { Navigation } from './Navigation'
import { Footer } from './Footer'
import PageLoader from '../components/PageLoader'
import PageTransition from './PageTransition'
import './haven-brand.css'

export const Landing = () => <div className='haven-site'>
  <Navigation />
  <Suspense fallback={<PageLoader />}><PageTransition /></Suspense>
  <Footer />
</div>
